<div class="text-center group">
      <div class="relative mb-4 overflow-hidden rounded-2xl shadow-primary-glow border border-border-subtle transition-all duration-500">
            <img [src]="member.image"
                  class="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-700">
            <div
                  class="absolute inset-0 bg-gradient-to-t from-bg-base/90 via-bg-base/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div class="absolute bottom-4 left-0 right-0 flex justify-center gap-3">
                        <a *ngIf="member.linkedinUrl" [href]="member.linkedinUrl"
                              class="w-10 h-10 flex items-center justify-center surface-elevated border border-border backdrop-blur rounded-xl hover:border-primary/50 transition-all shadow-md group/social">
                              <i class="fa-brands fa-linkedin-in text-text-secondary group-hover/social:text-primary transition-colors text-sm"></i>
                        </a>
                        <a *ngIf="member.twitterUrl" [href]="member.twitterUrl"
                              class="w-10 h-10 flex items-center justify-center surface-elevated border border-border backdrop-blur rounded-xl hover:border-primary/50 transition-all shadow-md group/social">
                              <i class="fa-brands fa-x-twitter text-text-secondary group-hover/social:text-primary transition-colors text-sm"></i>
                        </a>
                  </div>
            </div>
      </div>
      <h3 class="text-lg font-semibold text-text-primary">{{ member.name }}</h3>
      <p class="text-text-secondary text-sm">{{ member.role }}</p>
</div>